module.exports = __webpack_public_path__ + "img/healthPro5.16763a14.png";